import React, { Component } from 'react'
import { Icon } from 'antd'
import './style.css'

class ExportCSV extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const IconMap = () => (
      <Icon type="check-circle" theme="filled" style={{ color: '#52c41a' }}/>
    )

    return (
      <div className={'center_modal'}>
        <div className={'big_icon'}>
          <IconMap/>
        </div>
        <div className={'big_title'}>Successful</div>
        <div className={'big_subtitle'}>CSV Generation Is Complete</div>
        {/*<div className={'big_detail_box'} />*/}
      </div>
    )
  }
}

export default ExportCSV
